import tito from "../../assets/team/team-images/tito.png"
import ariana from "../../assets/team/team-images/ariana.png"
import nandan from "../../assets/team/team-images/nandan.png"
import finnegan from "../../assets/team/team-images/finnegan.png"
import oreo from "../../assets/team/team-images/oreo.png"
import sophie from "../../assets/team/team-images/sophie.png"
import aleks from "../../assets/team/team-images/aleks.png"
import jeff from "../../assets/team/team-images/jeff.png"
import srini from "../../assets/team/team-images/srini.png"
import lila from "../../assets/team/team-images/lila.png"

const teamData = [

  {
    id: 1,
    name: "Tito",
    jobTitle: "Motion Graphics + Cinematographer",
    image: tito,
    description: "The Diego Hargreeves (#2) of Motion Graphics and Production",
    linkedin: "https://www.linkedin.com/in/tito-ferradans-a65000101/",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },

  {
    id: 2,
    name: "Nandan",
    jobTitle: "Visual Effects + Technology",
    image: nandan,
    description: "The Number 5 of VFX and Pipeline Development",
    linkedin: "https://www.linkedin.com/in/nandanmylavarapu/",
    answer1: "asdas",
    answer2: "",
    answer3: "",
    answer4: "",
  },

  {
    id: 3,
    name: "Ariana",
    jobTitle: "Visual Effects + Producer",
    image: ariana,
    description: "The Klaus Hargreeves (#4) of VFX and VP",
    linkedin: "https://www.linkedin.com/in/ariana-saadat-2b5ab84a/",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
  {
    id: 4,
    name: "Jeff",
    jobTitle: "Editor",
    image: jeff,
    description: "",
    linkedin: "",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
  {
    id: 5,
    name: "Srini",
    jobTitle: "Colorist",
    image: srini,
    description: "",
    linkedin: "",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
  {
    id: 6,
    name: "Lila",
    jobTitle: "Cinematographer",
    image: lila,
    description: "",
    linkedin: "https://www.linkedin.com/in/lila-ferradans-20152367/",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
  {
    id: 7,
    name: "Aleks",
    jobTitle: "Junior Motion Designer",
    image: aleks,
    description: "Thing #1 of Motion Graphics",
    linkedin: "https://www.linkedin.com/in/aleks-mitic-48600a264/",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
  {
    id: 8,
    name: "Sophie",
    jobTitle: "Assistant Technical Director ",
    image: sophie,
    description: "Thing #2 of Technology",
    linkedin: "https://www.linkedin.com/in/sophier8817/",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
  {
    id: 9,
    name: "Finnegan",
    jobTitle: "Meow-tion Graphics Artist",
    image: finnegan,
    description: "The Klaus Hargreeves (#4) of VFX and VP",
    linkedin: "https://www.linkedin.com/in/finnegan-the-cat-2671bb373/",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
    {
    id: 10,
    name: "Oreo",
    jobTitle: "Paw-ducer",
    image: oreo,
    description: "The Klaus Hargreeves (#4) of VFX and VP",
    linkedin: "",
    answer1: "",
    answer2: "",
    answer3: "",
    answer4: "",
  },
];

export default teamData